import { render, staticRenderFns } from "./help6.vue?vue&type=template&id=2ef3292a&scoped=true"
import script from "./help6.vue?vue&type=script&lang=js"
export * from "./help6.vue?vue&type=script&lang=js"
import style0 from "./help6.vue?vue&type=style&index=0&id=2ef3292a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3292a",
  null
  
)

export default component.exports